import gql from 'graphql-tag'
import createQuery from 'legacy/apollo/createQuery'

export const configurationGraphQL = gql`
  query configuration {
    configuration {
      knowledgeOwl {
        projectId
        oauthToken
        domain
      }
    }
  }
`

export interface KnowledgeOwl {
  projectId: string
  domain: string
  oauthToken: string
}

export interface ConfigurationData {
  configuration: {
    knowledgeOwl: KnowledgeOwl
  }
}

export const configurationQuery = createQuery<ConfigurationData, {}>(configurationGraphQL)
